import TextField from "@mui/material/TextField";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import LoupeValidationEngine from '../LoupeValidationEngine';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';

const LoupeTextFieldComponent = props => {

    const currentItem = props.currentItem;

    const [ textValue, setTextValue ] = useState( currentItem.selectedValue );

    const handleChange = event => {

        setTextValue(event.target.value);
        currentItem.selectedValue = event.target.value;
        
        if( event.target.value == "")
        {
            currentItem.validator.untouch();
        } else {
            currentItem.validator.touched();
        }

        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }
    }

    const componentLabel = currentItem.boxPrompt; //currentItem.label + (currentItem.required ? '*' : '');
    
    return (

        <div className="text-start mb-4">
            <LoupeItemHeaderComponent currentItem={currentItem} />
            <TextField 
                id={currentItem.id} 
                fullWidth                                                     
                label={componentLabel} 
                sx={{ border: 'red' }} 
                variant="outlined"       
                value={textValue}                                                                                                                                                                                                     
                onChange={handleChange}
            />                                                
        </div>        


    );

}
export default LoupeTextFieldComponent;